import "./Policy.css";

function CookiePolicy() {
  return (
    <div className="lp-page">

      <div className="lp-hero">
        <div className="lp-hero-tag">🍪 Cookies</div>
        <h1>Cookie Policy</h1>
        <p>We only use what's necessary to keep you logged in and the platform working.</p>
      </div>

      <div className="lp-container">
        <div className="lp-meta">
          <span>Last updated: March 2025</span>
          <span className="lp-meta-dot" />
          <span>Learnlia</span>
        </div>

        <div className="lp-section">
          <h2>What Are Cookies</h2>
          <p>
            Cookies are small text files stored in your browser when you visit a website.
            They allow the site to remember information about your session — like whether
            you're logged in.
          </p>
        </div>

        <div className="lp-section">
          <h2>What We Use Cookies For</h2>
          <p>Learnlia uses a minimal set of cookies:</p>
          <ul>
            <li><strong>Authentication:</strong> To keep you logged in across sessions</li>
            <li><strong>Session management:</strong> To maintain your active state securely</li>
            <li><strong>Preferences:</strong> To remember settings like dark mode</li>
          </ul>
          <div className="lp-callout">
            We do <strong>not</strong> use advertising cookies, tracking cookies,
            or third-party analytics cookies.
          </div>
        </div>

        <div className="lp-section">
          <h2>Third-Party Cookies</h2>
          <p>
            When you watch videos through the embedded YouTube player, YouTube may set
            its own cookies. These are governed by Google's cookie and privacy policy,
            not Learnlia's.
          </p>
        </div>

        <div className="lp-section">
          <h2>Managing Cookies</h2>
          <p>
            You can disable cookies in your browser settings at any time. However,
            disabling authentication cookies will prevent you from staying logged in
            and may affect core platform functionality.
          </p>
        </div>

        <div className="lp-section">
          <h2>Contact</h2>
          <p>
            Questions about our cookie use? Email us at{" "}
            <a href="mailto:learnliadev@gmail.com" style={{ color: "var(--accent)" }}>
              learnliadev@gmail.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default CookiePolicy;